/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

export default function Sidebar() {
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  return (
    <>
      <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Toggler */}
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
          >
            <i className="fas fa-bars"></i>
          </button>
          {/* Brand */}
          
          <Link
            className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-lg uppercase font-bold px-0"
            to="/"
          >
            <img alt="logo" className="w-full border-none" src={require("assets/img/vending_logo.png").default} />
          </Link>

          {/* Collapse */}
          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
            style={{
              zIndex: 9999,
            }}
          >
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    VENDING
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Divider */}
            <hr className="my-3 md:min-w-full" />
            {/* Heading */}

            {/* Navigation */}

            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/dashboard") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/dashboard"
                >
                  <i
                    className={
                      "fas fa-chart-line fa-lg mr-2" + (window.location.href.indexOf("/admin/dashboard") !== -1 ? "opacity-75" : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Dashboard
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/companies") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/companies"
                >
                  <i
                    className={
                      "fas fa-building fa-lg mr-2" + (window.location.href.indexOf("/admin/companies") !== -1 ? "opacity-75" : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Companies
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/products") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/products"
                >
                  <i
                    className={
                      "fas fa-box fa-lg mr-2" + (window.location.href.indexOf("/admin/products") !== -1 ? "opacity-75" : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Products
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/invoices") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/invoices"
                >
                  <i
                    className={
                      "fas fa-file-invoice fa-lg mr-2" + (window.location.href.indexOf("/admin/invoices") !== -1 ? "opacity-75" : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Invoices
                </Link>
              </li>
            </ul>
          </div>
          <footer>
          <hr className="my-3 md:min-w-full" />
            <div className="text-sm text-blueGray-500 font-semibold py-1 pb-1 pt-3 text-center md:text-left">
              Copyright © {new Date().getFullYear()} VENDING All Rights Reserved.
            </div>
          </footer>
        </div>
      </nav>
    </>
  );
}
